


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { BForm, BFormGroup, BFormInput, BFormCheckbox, BContainer, BButton, BRow, BCol, BFormTextarea, BFormInvalidFeedback, BOverlay } from 'bootstrap-vue';
import Configuration from '@/types/Configuration';
import Validator, { handleValidationErrors } from '@/types/Validator';
import SpinnerButton from '@/components/SpinnerButton.vue';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

@Component({
    components: {
        'b-overlay': BOverlay,
        'b-container': BContainer,
        'b-row': BRow,
        'b-col': BCol,
        'b-form': BForm,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-invalid-feedback': BFormInvalidFeedback,
        'b-form-textarea': BFormTextarea,
        'b-form-checkbox': BFormCheckbox,
        'b-btn': BButton,
        'spinner-btn': SpinnerButton
    }
})
export default class OperationDetails extends Vue {
    @Prop() operationId!: string

    apiAccessToken = this.$store.state.apiAccessToken
    isBusy = true;
    isBusySave = false;
    isBusyDelete = false;
    operation: OperationData = {
        id: ''
    };

    nameValidator: Validator = {
        isValid: null,
        errors: []
    }

    mounted() {
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadOperation(this.operationId);
    }

    clearValidators() {
        this.nameValidator = {
            isValid: null,
            errors: []
        }
    }

    async loadOperation(operationId: string) {
        if (operationId.length == 0) {
            this.isBusy = false;
            return;
        }

        this.isBusy = true;

        try {
            const response = await AxiosService.request<OperationData>({
                url: `operationsadministration/${operationId}`,
                method: 'GET'
            });

            this.operation = response.data;
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
        }
    }

    onSubmit(e: Event) { // eslint-disable-line @typescript-eslint/no-unused-vars
        this.isBusy = true;
        this.isBusySave = true;

        this.clearValidators();

        try {
            AxiosService.request<boolean>({
                url: `operationsadministration`,
                method: 'POST',
                data: this.operation
            });

            this.$root.$bvToast.toast(this.$t('toaster.operationSaved') as string, {
                title: this.$t('toaster.saveOperationTitle') as string,
                autoHideDelay: Configuration.ToasterAutoHideDelay,
                appendToast: true,
                variant: Configuration.ToasterVariantSuccess,
                toaster: Configuration.ToasterPosition
            });
            this.$emit('operation-saved', true);
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    case 400:
                        handleValidationErrors(this, error.response.data.errors.Name, this.nameValidator);
                        return;
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
        finally {
            this.isBusy = false;
            this.isBusySave = false;
        }
    }

    deleteOperation() {
        this.$bvModal.msgBoxConfirm(this.$t('modal.confirmOperationDeleteMessage') as string, {
            title: this.$t('modal.confirmOperationDeleteTitle') as string,
            centered: true,
            buttonSize: 'sm',
            okTitle: this.$t('modal.confirmOkTitle') as string,
            cancelTitle: this.$t('modal.confirmCancelTitle') as string
        })
            .then(value => {
                if (value) {
                    this.isBusy = true;
                    this.isBusyDelete = true;

                    try {
                        AxiosService.request<boolean>({
                            url: `operationsadministration?id=${this.operationId}`,
                            method: 'DELETE'
                        });

                        this.$root.$bvToast.toast(this.$t('toaster.operationDeleted') as string, {
                            title: this.$t('toaster.deleteOperationTitle') as string,
                            autoHideDelay: Configuration.ToasterAutoHideDelay,
                            appendToast: true,
                            variant: Configuration.ToasterVariantSuccess,
                            toaster: Configuration.ToasterPosition
                        });
                        this.$emit('operation-deleted', true);
                    }
                    catch (error) {
                        if (error.response) {
                            switch (error.response.status) {
                                case 404:
                                    return this.$router.push(`/${i18n.locale}/notfound`);
                                case 403:
                                    return this.$router.push(`/${i18n.locale}/accessdenied`);
                                default:
                                    return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                            }
                        }
                    }
                    finally {
                        this.isBusy = false;
                        this.isBusyDelete = false;
                    }
                }
            })
            .catch(error => {
                console.error(error);
            });
    }
}

interface OperationData {
    id: string;
}
